import JsonLd from 'components/JsonLd';

/**
 * items: [{ question: string, answer: string }, ...]
 * Рендерит null если items пустой или отсутствует.
 */
const FAQJsonLd = ({ items }) => {
  if (!items?.length) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map(({ question, answer }) => ({
      "@type": "Question",
      "name": question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": answer
      }
    }))
  };

  return <JsonLd data={schema} />;
};

export default FAQJsonLd;
